import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useHistory } from "react-router-dom";
import { Button } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

import { Routes } from "../../routes";

import "./VerifyEmail.css";
import BASE_URL from "../../config";


const VerifyEmail = () => {

  const location = useLocation();
  const history = useHistory();

  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {

    const params = new URLSearchParams(
      location.search
    );

    const token = params.get("token");

    if (!token) {

      setStatus("error");

      setMessage(
        "Invalid verification link."
      );

      return;
    }

    verifyEmail(token);

  }, [location.search]);

  const verifyEmail = async (token) => {

    try {

      const response = await axios.post(
        `${BASE_URL}/api.php`,
        {
          type: "VerifyEmail",
          token: token,
        }
      );

      if (response.data.status === "success") {

        setStatus("success");

        setMessage(
          response.data.message
        );

      } else {

        setStatus("error");

        setMessage(
          response.data.message ||
          "Email verification failed."
        );
      }

    } catch (error) {

      console.error(
        "Email verification error:",
        error
      );

      setStatus("error");

      setMessage(
        error.response?.data?.message ||
        "Unable to verify your email."
      );
    }
  };

  return (
    <main className="verify-page">

      <div className="verify-card">

        {status === "verifying" && (
          <>
            <FontAwesomeIcon
              icon={faSpinner}
              spin
              size="3x"
              className="verify-icon"
            />

            <h2>
              Verifying Your Email
            </h2>

            <p>
              Please wait while we verify
              your email address...
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <FontAwesomeIcon
              icon={faCheckCircle}
              size="3x"
              className="verify-success-icon"
            />

            <h2>
              Email Verified Successfully
            </h2>

            <p>
              {message}
            </p>

            <Button
              className="verify-login-btn"
              onClick={() =>
                history.push(
                  Routes.Signin.path
                )
              }
            >
              Go to Login
            </Button>
          </>
        )}

        {status === "error" && (
          <>
            <FontAwesomeIcon
              icon={faTimesCircle}
              size="3x"
              className="verify-error-icon"
            />

            <h2>
              Verification Failed
            </h2>

            <p>
              {message}
            </p>

            <Button
              variant="secondary"
              onClick={() =>
                history.push(
                  Routes.Signup.path
                )
              }
            >
              Back to Signup
            </Button>
          </>
        )}

      </div>

    </main>
  );
};

export default VerifyEmail;